export default __webpack_public_path__ + "static/titleLogo-min-d917ac2cba30cb27124cba7cacb1013c.png";